import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa"; // Import "Open Web" icon
import "./WebinarsListing.css";
import WebViewCard from "../../components/commonComponent/WebViewCard";

const API_URL = process.env.REACT_APP_API_URL;

const WebinarWebView = () => {
  const [webinars, setWebinars] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWebinars = async () => {
      const response = await fetch(`${API_URL}/getAllWebinars`);
      const data = await response.json();
      console.log(data, "Fetched Webinars");

      if (data?.data?.length === 1) {
        navigate(`/webinar/${data?.data[0]?._id}`);
      }
      setWebinars(data?.data || []);
    };

    fetchWebinars();
  }, []);

  return (
    <div className="blog-listing">
      <div className="blog-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {webinars.length > 0 ? (
          webinars.map((webinar) => (
           <WebViewCard  key={webinar.id} title={webinar.title} path={webinar.link} newWindow={true} />
          ))
        ) : (
          <p className="text-gray-600 text-center">Loading webinars...</p>
        )}
      </div>
    </div>
  );
};

export default WebinarWebView;
